export default __webpack_public_path__ + "static/media/authorised.0e10e563.svg";